const calculateEmergencyPto = (leaveData:any)=>{
console.log(leaveData,"from hooks")
const emergencyCount = leaveData?.filter((data:any)=>{
   return data.leave_type_id === 2 || data.leave_type_id === '2'
}).reduce((acc:any,curr:any)=>{
return curr.duration + acc
},0)
const compOff = leaveData?.filter((data:any)=>{
    return data?.leave_type_id===5 || data?.leave_type_id === '5'
}).reduce((acc:any,curr:any)=>{
return curr.duration + acc
},0)  
return  {emergencyCount,
    compOff
}}
export default calculateEmergencyPto

